module.exports = __webpack_public_path__ + "media/images/germany-flag-round-e39a898c613b6371ca30c5d6bcd84058.png";